if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        
        this.submitButtonText = this.submitButton.querySelector('span');
        const shopifySection = this.closest('.shopify-section');
        this.addOnform = shopifySection ? shopifySection.querySelector('addon-product') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.hasMultiVariants = this.dataset.multiVariants === 'true';
        this.hasMultiVariants = shopifySection && shopifySection.querySelector('product-configurator') ? true : false;
        this.useParentId = this.dataset.useParentId === 'true' || this.dataset.useParentId === undefined;
      }

      addMultipleVariants(mainItemId) {
        const multiVariantSelects =
          this.closest('product-configurator')?.querySelector('product-configurator-products') ||
          this.closest('.shopify-section')?.querySelector('product-configurator');

        if (!multiVariantSelects) {
          return [];
        }

        const items = [];
        const selectedInputs = multiVariantSelects.querySelectorAll('input:checked');
        const selectedSelects = multiVariantSelects.querySelectorAll('select');

        selectedInputs.forEach((input) => {
          items.push({
            quantity: 1,
            id: input.value,
            parent_id: this.useParentId ? mainItemId : undefined,
          });
        });

        selectedSelects.forEach((select) => {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.hasAttribute('data-single-variant') && selectedOption.value) {
            items.push({
              quantity: 1,
              id: selectedOption.value,
              parent_id: this.useParentId ? mainItemId : undefined,
            });
          }
        });

        return items;
      }

      getItems() {
        const formData = JSON.parse(serializeForm(this.form));
        let properties = this.getSelectedProperties(formData);

        // Always include the main item with updated properties for addons
        const mainItem = properties
          ? this.createItemWithProperties(formData, properties)
          : this.createItemFromForm(formData);

        if (this.hasAddons) {
          // Update properties of the main item with addon data
          this.addAddonProperties(mainItem);
        }

        if (this.hasMultiVariants) {
          const items = this.addMultipleVariants(mainItem.id);
          const productConfigurator = this.closest('.shopify-section').querySelector('product-configurator');
          if (productConfigurator && productConfigurator.dataset.includeMainProduct === 'true') {
            const productTitle = productConfigurator.dataset.productTitle;
            items.forEach((item) => {
              item.properties = {
                ...item.properties,
                'Product': productTitle,
              };
            });
            items.unshift(mainItem);
          }
          return { items };
        } else {
          return { items: [mainItem] };
        }
      }

      getSelectedProperties(formData) {
        if (formData.properties) {
          return Object.entries(formData.properties)
            .filter(([key, value]) => value) // Include only non-empty values
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});
        }
        return {};
      }

      createItemWithProperties(formData, properties) {
        return {
          quantity: formData.quantity,
          id: formData.id,
          properties: {
            ...this.getSelectedProperties({ properties }),
          },
        };
      }

      createItemFromForm(formData) {
        return {
          quantity: formData.quantity,
          id: formData.id,
        };
      }

      addAddonProperties(mainItem) {
        const checkboxes = this.addOnform.querySelectorAll('input[type="radio"]:checked');
        checkboxes.forEach((checkbox) => {
          const addonName = checkbox.name || 'Addon';
          const addonValue = checkbox.value;

          // Add each addon as a custom property
          mainItem.properties[`Addon - ${addonName}`] = addonValue;
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.dataset.type == 'add-to-box') return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const items = this.getItems();
        const productFormData = this.getProductFormData(items);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          ...productFormData,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (response.status === 422 && this.dataset.continueSelling) {
                window.location = window.routes.cart_url;
                return;
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal && this.cart) {
              quickAddModal.hide(true);
              setTimeout(() => {
                this.cart.renderContents(response);
              }, 150);
            } else if (this.cart) {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const spinner = this.querySelector('.loading-overlay__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      getProductFormData(items) {

        return items;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        super.show(opener);


        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}